module.exports = __webpack_public_path__ + "static/media/header_album_tachibanaaa50f8ec382c7f05964be53a598b21e4.webp";